import { render, staticRenderFns } from "./channel2.vue?vue&type=template&id=7e0fb210&"
import script from "./channel2.vue?vue&type=script&lang=js&"
export * from "./channel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports